export default "__VITE_ASSET__CtGob71h__"